<button mat-button [matMenuTriggerFor]="menu"
  [class]="buttonClass"
  aria-label="Change language">
  <span class="material-icons">translate</span>
  {{ getCurrentLanguageDisplay() | uppercase }}
</button>

<mat-menu #menu="matMenu" class="language-menu" (menuOpened)="onMenuOpened()">
  <!-- Search input -->
  <div class="language-search" (click)="onSearchClick($event)">
    <mat-icon class="search-icon">search</mat-icon>
    <input type="text"
           placeholder="Search languages..."
           [value]="searchTerm()"
           (input)="onSearchInput($event)"
           (keydown)="onSearchKeydown($event)"
           autocomplete="off">
  </div>

  <!-- Grouped languages -->
  <div class="language-list">
    <ng-container *ngFor="let group of filteredGroups()">
      <div class="region-header">{{ group.region }}</div>
      <button mat-menu-item
              *ngFor="let lang of group.languages"
              (click)="setLanguage(lang.code)"
              [lang]="lang.code"
              class="language-menu-item"
              [class.active-lang]="isCurrentLang(lang.code)">
        <span class="language-native">{{ lang.nativeName }}</span>
        <span class="language-english">{{ lang.name }}</span>
        <mat-icon *ngIf="isCurrentLang(lang.code)" class="check-icon">check</mat-icon>
      </button>
    </ng-container>

    <div *ngIf="filteredGroups().length === 0" class="no-results">
      No languages found
    </div>
  </div>
</mat-menu>
